"use client";
import { useRef, useEffect, useState, useMemo } from "react";
import UpSetJS, { extractSets } from "@upsetjs/react";
import { lab } from "d3-color";

function mergeColors(colors) {
  if (colors.length === 0) return undefined;
  if (colors.length === 1) return colors[0];
  const cc = colors.reduce(
    (acc, d) => {
      const c = lab(d || "transparent");
      return {
        l: acc.l + c.l,
        a: acc.a + c.a,
        b: acc.b + c.b,
      };
    },
    { l: 0, a: 0, b: 0 }
  );
  return lab(
    cc.l / colors.length,
    cc.a / colors.length,
    cc.b / colors.length
  ).toString();
}

const highchartsColors = [
  "#7cb5ec",
  "#434348",
  "#90ed7d",
  "#f7a35c",
  "#8085e9",
  "#f15c80",
  "#e4d354",
  "#2b908f",
  "#f45b5b",
  "#91e8e1",
];

function UpsetChart({ rawData }) {
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 500, height: 300 });
  const [selection, setSelection] = useState(null);

  useEffect(() => {
    function updateDimensions() {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        const height = width * 0.6;
        setDimensions({ width, height });
      }
    }

    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const elems = useMemo(() => {
    const e = [];
    let counter = 1;
    for (const [key, count] of Object.entries(rawData)) {
      const sets = key.split(",").map((s) => s.trim());
      for (let i = 0; i < count; i++) {
        e.push({
          name: `item${counter++}`,
          sets,
        });
      }
    }
    return e;
  }, [rawData]);

  const sets = useMemo(() => {
    const extracted = extractSets(elems);
    const colorMap = {};
    extracted.forEach((s, index) => {
      colorMap[s.name] = highchartsColors[index % highchartsColors.length];
    });

    return extracted.map((s) => ({
      ...s,
      color: colorMap[s.name],
    }));
  }, [elems]);

  return (
    <div ref={containerRef} style={{ width: "100%", position: "relative" }}>
      <UpSetJS
        sets={sets}
        width={dimensions.width}
        height={dimensions.height}
        setName="Tamaño del conjunto"
        combinationName="Tamaño de la intersección"
        combinations={{ mergeColors }}
        selection={selection}
        onHover={setSelection}
        hasSelectionOpacity={0.4}
        selectionColor=""
      />
    </div>
  );
}

export default UpsetChart;
